import { ReplaySubject  } from "rxjs";

const $keys = new ReplaySubject (1);

export const keysService = {
  getKeys: () => $keys,
  getKey: (pattern) => $keys.take(1).subscribe(),
  setKeys: (token) => $keys.next(token),
};
